import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { bool_type, record_type, list_type, class_type, union_type, int32_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Billing", "ReceiptS1", "BillingFileContent", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.Billing.Model.Page", [], Page, () => [[], [["Item", option_type(string_type)]], [["Item1", string_type], ["Item2", string_type], ["Item3", int32_type]], []]);
}

export class ClientInfoDTO extends Record {
    constructor(ClientName, ClientNr, DefaultMortgageApprovalType, InvoiceDate, InvoiceDueDate, InvoiceFileFormat, InvoiceNetDays, InvoicePeriodEnd, MinimumInvoiceAmountInclVat, MortgageNetDays, MortgageNr, PaymentTermsNetDays) {
        super();
        this.ClientName = ClientName;
        this.ClientNr = (ClientNr | 0);
        this.DefaultMortgageApprovalType = (DefaultMortgageApprovalType | 0);
        this.InvoiceDate = InvoiceDate;
        this.InvoiceDueDate = InvoiceDueDate;
        this.InvoiceFileFormat = InvoiceFileFormat;
        this.InvoiceNetDays = (InvoiceNetDays | 0);
        this.InvoicePeriodEnd = InvoicePeriodEnd;
        this.MinimumInvoiceAmountInclVat = MinimumInvoiceAmountInclVat;
        this.MortgageNetDays = (MortgageNetDays | 0);
        this.MortgageNr = (MortgageNr | 0);
        this.PaymentTermsNetDays = (PaymentTermsNetDays | 0);
    }
}

export function ClientInfoDTO$reflection() {
    return record_type("Containers.Billing.Model.ClientInfoDTO", [], ClientInfoDTO, () => [["ClientName", string_type], ["ClientNr", int32_type], ["DefaultMortgageApprovalType", int32_type], ["InvoiceDate", class_type("System.DateOnly")], ["InvoiceDueDate", class_type("System.DateOnly")], ["InvoiceFileFormat", list_type(string_type)], ["InvoiceNetDays", int32_type], ["InvoicePeriodEnd", class_type("System.DateOnly")], ["MinimumInvoiceAmountInclVat", class_type("System.Decimal")], ["MortgageNetDays", int32_type], ["MortgageNr", int32_type], ["PaymentTermsNetDays", int32_type]]);
}

export class UpdateClientInfoDTO extends Record {
    constructor(InvoiceNetDays, PaymentTermsNetDays) {
        super();
        this.InvoiceNetDays = (InvoiceNetDays | 0);
        this.PaymentTermsNetDays = (PaymentTermsNetDays | 0);
    }
}

export function UpdateClientInfoDTO$reflection() {
    return record_type("Containers.Billing.Model.UpdateClientInfoDTO", [], UpdateClientInfoDTO, () => [["InvoiceNetDays", int32_type], ["PaymentTermsNetDays", int32_type]]);
}

export class BillingDTO extends Record {
    constructor(Acceptable, AcceptedBy, Batch, BatchId, CanRollback, ElapsedSeconds, InitiatedUtc, InitiatedBy, InitiationKey, RollbackedBy, StartedUtc, State, StatusCode, StatusUtc, StatusMessage, Type) {
        super();
        this.Acceptable = Acceptable;
        this.AcceptedBy = AcceptedBy;
        this.Batch = Batch;
        this.BatchId = (BatchId | 0);
        this.CanRollback = CanRollback;
        this.ElapsedSeconds = ElapsedSeconds;
        this.InitiatedUtc = InitiatedUtc;
        this.InitiatedBy = InitiatedBy;
        this.InitiationKey = InitiationKey;
        this.RollbackedBy = RollbackedBy;
        this.StartedUtc = StartedUtc;
        this.State = State;
        this.StatusCode = (StatusCode | 0);
        this.StatusUtc = StatusUtc;
        this.StatusMessage = StatusMessage;
        this.Type = Type;
    }
}

export function BillingDTO$reflection() {
    return record_type("Containers.Billing.Model.BillingDTO", [], BillingDTO, () => [["Acceptable", bool_type], ["AcceptedBy", string_type], ["Batch", string_type], ["BatchId", int32_type], ["CanRollback", bool_type], ["ElapsedSeconds", option_type(int32_type)], ["InitiatedUtc", UTC$reflection()], ["InitiatedBy", string_type], ["InitiationKey", string_type], ["RollbackedBy", string_type], ["StartedUtc", option_type(UTC$reflection())], ["State", string_type], ["StatusCode", int32_type], ["StatusUtc", option_type(UTC$reflection())], ["StatusMessage", string_type], ["Type", string_type]]);
}

export class PlotPoint extends Record {
    constructor(AmountExclVat, AmountExclVatTraffic, Period) {
        super();
        this.AmountExclVat = (AmountExclVat | 0);
        this.AmountExclVatTraffic = (AmountExclVatTraffic | 0);
        this.Period = Period;
    }
}

export function PlotPoint$reflection() {
    return record_type("Containers.Billing.Model.PlotPoint", [], PlotPoint, () => [["AmountExclVat", int32_type], ["AmountExclVatTraffic", int32_type], ["Period", class_type("System.DateOnly")]]);
}

export class InvoiceBatch extends Record {
    constructor(Color, Label, Values) {
        super();
        this.Color = Color;
        this.Label = Label;
        this.Values = Values;
    }
}

export function InvoiceBatch$reflection() {
    return record_type("Containers.Billing.Model.InvoiceBatch", [], InvoiceBatch, () => [["Color", string_type], ["Label", string_type], ["Values", list_type(PlotPoint$reflection())]]);
}

export class BillingInfo extends Record {
    constructor(InvoiceDate, InvoiceDaysDiff, IsCurrentInvoiceMonth, LastInvoiceDate) {
        super();
        this.InvoiceDate = InvoiceDate;
        this.InvoiceDaysDiff = (InvoiceDaysDiff | 0);
        this.IsCurrentInvoiceMonth = IsCurrentInvoiceMonth;
        this.LastInvoiceDate = LastInvoiceDate;
    }
}

export function BillingInfo$reflection() {
    return record_type("Containers.Billing.Model.BillingInfo", [], BillingInfo, () => [["InvoiceDate", class_type("System.DateOnly")], ["InvoiceDaysDiff", int32_type], ["IsCurrentInvoiceMonth", bool_type], ["LastInvoiceDate", option_type(class_type("System.DateOnly"))]]);
}

export class BillingFileDTO extends Record {
    constructor(Filename, Fullpath, FullpathZipped, Valid) {
        super();
        this.Filename = Filename;
        this.Fullpath = Fullpath;
        this.FullpathZipped = FullpathZipped;
        this.Valid = Valid;
    }
}

export function BillingFileDTO$reflection() {
    return record_type("Containers.Billing.Model.BillingFileDTO", [], BillingFileDTO, () => [["Filename", string_type], ["Fullpath", string_type], ["FullpathZipped", string_type], ["Valid", bool_type]]);
}

export class OmniChannelDTO extends Record {
    constructor(ImportedOmnichannel) {
        super();
        this.ImportedOmnichannel = ImportedOmnichannel;
    }
}

export function OmniChannelDTO$reflection() {
    return record_type("Containers.Billing.Model.OmniChannelDTO", [], OmniChannelDTO, () => [["ImportedOmnichannel", bool_type]]);
}

export class BillingStatisticsDTO extends Record {
    constructor(CanDownloadWholesaleFeesummary, CanDownloadXMLInvoiceFile, Contracts, Digipost, DigipostWithDirectDebitWithDistribution, DigipostWithDirectDebitWithNoDistribution, DigipostWithNoDirectDebit, DirectDebitWithDistribution, DirectDebitWithNoDistribution, EInvoice, EInvoiceEHF, EInvoiceEHFWithDirectDebitWithDistribution, EInvoiceEHFWithDirectDebitWithNoDistribution, EInvoiceEHFWithNoDirectDebit, EInvoiceWithDirectDebitWithDistribution, EInvoiceWithDirectDebitWithNoDistribution, EInvoiceWithNoDirectDebit, Email, EmailWithDirectDebitWithDistribution, EmailWithDirectDebitWithNoDistribution, EmailWithNoDirectDebit, NoDirectDebit, NotDistributed, NotDistributedWithDirectDebitWithDistribution, NotDistributedWithDirectDebitWithNoDistribution, NotDistributedWithNoDirectDebit, Paper, PaperWithDirectDebitWithDistribution, PaperWithDirectDebitWithNoDistribution, PaperWithNoDirectDebit, Peppol, PeppolWithDirectDebitWithDistribution, PeppolWithDirectDebitWithNoDistribution, PeppolWithNoDirectDebit, Phonenumbers, TotalAmountExclVat, TotalInvoices, TotalVat) {
        super();
        this.CanDownloadWholesaleFeesummary = CanDownloadWholesaleFeesummary;
        this.CanDownloadXMLInvoiceFile = CanDownloadXMLInvoiceFile;
        this.Contracts = (Contracts | 0);
        this.Digipost = (Digipost | 0);
        this.DigipostWithDirectDebitWithDistribution = (DigipostWithDirectDebitWithDistribution | 0);
        this.DigipostWithDirectDebitWithNoDistribution = (DigipostWithDirectDebitWithNoDistribution | 0);
        this.DigipostWithNoDirectDebit = (DigipostWithNoDirectDebit | 0);
        this.DirectDebitWithDistribution = (DirectDebitWithDistribution | 0);
        this.DirectDebitWithNoDistribution = (DirectDebitWithNoDistribution | 0);
        this.EInvoice = (EInvoice | 0);
        this.EInvoiceEHF = (EInvoiceEHF | 0);
        this.EInvoiceEHFWithDirectDebitWithDistribution = (EInvoiceEHFWithDirectDebitWithDistribution | 0);
        this.EInvoiceEHFWithDirectDebitWithNoDistribution = (EInvoiceEHFWithDirectDebitWithNoDistribution | 0);
        this.EInvoiceEHFWithNoDirectDebit = (EInvoiceEHFWithNoDirectDebit | 0);
        this.EInvoiceWithDirectDebitWithDistribution = (EInvoiceWithDirectDebitWithDistribution | 0);
        this.EInvoiceWithDirectDebitWithNoDistribution = (EInvoiceWithDirectDebitWithNoDistribution | 0);
        this.EInvoiceWithNoDirectDebit = (EInvoiceWithNoDirectDebit | 0);
        this.Email = (Email | 0);
        this.EmailWithDirectDebitWithDistribution = (EmailWithDirectDebitWithDistribution | 0);
        this.EmailWithDirectDebitWithNoDistribution = (EmailWithDirectDebitWithNoDistribution | 0);
        this.EmailWithNoDirectDebit = (EmailWithNoDirectDebit | 0);
        this.NoDirectDebit = (NoDirectDebit | 0);
        this.NotDistributed = (NotDistributed | 0);
        this.NotDistributedWithDirectDebitWithDistribution = (NotDistributedWithDirectDebitWithDistribution | 0);
        this.NotDistributedWithDirectDebitWithNoDistribution = (NotDistributedWithDirectDebitWithNoDistribution | 0);
        this.NotDistributedWithNoDirectDebit = (NotDistributedWithNoDirectDebit | 0);
        this.Paper = (Paper | 0);
        this.PaperWithDirectDebitWithDistribution = (PaperWithDirectDebitWithDistribution | 0);
        this.PaperWithDirectDebitWithNoDistribution = (PaperWithDirectDebitWithNoDistribution | 0);
        this.PaperWithNoDirectDebit = (PaperWithNoDirectDebit | 0);
        this.Peppol = (Peppol | 0);
        this.PeppolWithDirectDebitWithDistribution = (PeppolWithDirectDebitWithDistribution | 0);
        this.PeppolWithDirectDebitWithNoDistribution = (PeppolWithDirectDebitWithNoDistribution | 0);
        this.PeppolWithNoDirectDebit = (PeppolWithNoDirectDebit | 0);
        this.Phonenumbers = (Phonenumbers | 0);
        this.TotalAmountExclVat = TotalAmountExclVat;
        this.TotalInvoices = (TotalInvoices | 0);
        this.TotalVat = TotalVat;
    }
}

export function BillingStatisticsDTO$reflection() {
    return record_type("Containers.Billing.Model.BillingStatisticsDTO", [], BillingStatisticsDTO, () => [["CanDownloadWholesaleFeesummary", bool_type], ["CanDownloadXMLInvoiceFile", bool_type], ["Contracts", int32_type], ["Digipost", int32_type], ["DigipostWithDirectDebitWithDistribution", int32_type], ["DigipostWithDirectDebitWithNoDistribution", int32_type], ["DigipostWithNoDirectDebit", int32_type], ["DirectDebitWithDistribution", int32_type], ["DirectDebitWithNoDistribution", int32_type], ["EInvoice", int32_type], ["EInvoiceEHF", int32_type], ["EInvoiceEHFWithDirectDebitWithDistribution", int32_type], ["EInvoiceEHFWithDirectDebitWithNoDistribution", int32_type], ["EInvoiceEHFWithNoDirectDebit", int32_type], ["EInvoiceWithDirectDebitWithDistribution", int32_type], ["EInvoiceWithDirectDebitWithNoDistribution", int32_type], ["EInvoiceWithNoDirectDebit", int32_type], ["Email", int32_type], ["EmailWithDirectDebitWithDistribution", int32_type], ["EmailWithDirectDebitWithNoDistribution", int32_type], ["EmailWithNoDirectDebit", int32_type], ["NoDirectDebit", int32_type], ["NotDistributed", int32_type], ["NotDistributedWithDirectDebitWithDistribution", int32_type], ["NotDistributedWithDirectDebitWithNoDistribution", int32_type], ["NotDistributedWithNoDirectDebit", int32_type], ["Paper", int32_type], ["PaperWithDirectDebitWithDistribution", int32_type], ["PaperWithDirectDebitWithNoDistribution", int32_type], ["PaperWithNoDirectDebit", int32_type], ["Peppol", int32_type], ["PeppolWithDirectDebitWithDistribution", int32_type], ["PeppolWithDirectDebitWithNoDistribution", int32_type], ["PeppolWithNoDirectDebit", int32_type], ["Phonenumbers", int32_type], ["TotalAmountExclVat", class_type("System.Decimal")], ["TotalInvoices", int32_type], ["TotalVat", class_type("System.Decimal")]]);
}

export class AffectedEntityDTO extends Record {
    constructor(InvoiceeNr, ContractNr, FeeNr) {
        super();
        this.InvoiceeNr = InvoiceeNr;
        this.ContractNr = ContractNr;
        this.FeeNr = FeeNr;
    }
}

export function AffectedEntityDTO$reflection() {
    return record_type("Containers.Billing.Model.AffectedEntityDTO", [], AffectedEntityDTO, () => [["InvoiceeNr", option_type(class_type("System.Int64"))], ["ContractNr", option_type(int32_type)], ["FeeNr", option_type(int32_type)]]);
}

export class ValidateDTO extends Record {
    constructor(Id, ValidateMessage, AffectedEntities) {
        super();
        this.Id = Id;
        this.ValidateMessage = ValidateMessage;
        this.AffectedEntities = AffectedEntities;
    }
}

export function ValidateDTO$reflection() {
    return record_type("Containers.Billing.Model.ValidateDTO", [], ValidateDTO, () => [["Id", string_type], ["ValidateMessage", string_type], ["AffectedEntities", list_type(AffectedEntityDTO$reflection())]]);
}

export class InvoiceeBatchDTO extends Record {
    constructor(InvoiceeBatchId, InvoiceeBatchName, IsCommitted) {
        super();
        this.InvoiceeBatchId = (InvoiceeBatchId | 0);
        this.InvoiceeBatchName = InvoiceeBatchName;
        this.IsCommitted = IsCommitted;
    }
}

export function InvoiceeBatchDTO$reflection() {
    return record_type("Containers.Billing.Model.InvoiceeBatchDTO", [], InvoiceeBatchDTO, () => [["InvoiceeBatchId", int32_type], ["InvoiceeBatchName", string_type], ["IsCommitted", bool_type]]);
}

export class BillingFileContentSearchDTO extends Record {
    constructor(NextIndex, ErrorMessage) {
        super();
        this.NextIndex = NextIndex;
        this.ErrorMessage = ErrorMessage;
    }
}

export function BillingFileContentSearchDTO$reflection() {
    return record_type("Containers.Billing.Model.BillingFileContentSearchDTO", [], BillingFileContentSearchDTO, () => [["NextIndex", option_type(int32_type)], ["ErrorMessage", option_type(string_type)]]);
}

